/**
 * A 3D deep dive into Kimi K3: one token's trip through a city laid out as
 * the model's own computation, with its own soundtrack. three.js is big, so
 * the player loads on its own, only on pages that show it, and never on the
 * server.
 */
import dynamic from "next/dynamic";

const Player = dynamic(() => import("./Player"), {
  ssr: false,
  loading: () => (
    <div className="not-prose my-10 relative left-1/2 -translate-x-1/2 w-[min(calc(100vw-2rem),64rem)] aspect-video rounded-xl border border-amber-900/60 bg-black" />
  )
});

export default function NeonCity() {
  return <Player />;
}
